$('br').attr('aria-hidden', 'true');

$('a').each(function () {
  // Check if the link is external
  if (this.hostname && this.hostname !== window.location.hostname && this.hostname !== 'https://www.playgosports.com/') {
    // Create a span element with warning text
    var warningSpan = $('<span class="visuallyhidden">: This link will open in a new tab.</span>');
    // Set attributes for accessibility
    $(this).attr('target', '_blank').attr('rel', 'noopener noreferrer');
    // Append the warning span inside the link
    $(this).append(warningSpan);
  }
});



 	document.addEventListener('DOMContentLoaded', function() {
  var backToTopButton = document.getElementById('back-to-top');

  window.onscroll = function() {
      if (window.pageYOffset > 300) {
          backToTopButton.style.display = 'block';
      } else {
          backToTopButton.style.display = 'none';
      }
  };

  backToTopButton.onclick = function(e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });

      // Set focus to the top of the page or the button itself after scrolling
      window.setTimeout(function() {
          document.getElementById('backtoheader').focus(); // If focusing the top element
          // backToTopButton.focus(); // If focusing the button itself
      }, 600); // Adjust the timeout duration to match the scroll duration
  };
});






document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.has-dropdown > a').forEach(function (link) {
    link.setAttribute('role', 'button');
  });
});



document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.has-dropdown > a').forEach(function (link) {
    link.removeAttribute('href');
  });
});







document.addEventListener("DOMContentLoaded", function () {

  // 🔹 Make links behave like buttons
  document.querySelectorAll('.has-dropdown > a').forEach(function (el) {
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    el.removeAttribute('href');
    el.setAttribute('aria-expanded', 'false'); 
  });

  // 🔹 TOGGLE function
  function toggleMenu(trigger) {
    const parent = trigger.closest('.has-dropdown');
    const menu = parent.querySelector('ul');
    if (!menu) return;

    const isHidden = menu.hasAttribute('hidden');
    if (isHidden) {
      menu.removeAttribute('hidden');
      trigger.setAttribute('aria-expanded', 'true');
    } else {
      menu.setAttribute('hidden', '');
      trigger.setAttribute('aria-expanded', 'false');
    }
  }

  // 🔹 CLICK / KEYDOWN (Enter / Space)
  document.querySelectorAll('.has-dropdown > a, .has-dropdown > button').forEach(function (trigger) {

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggleMenu(trigger);
    });

    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        toggleMenu(trigger);
      }
    });

  });

  // 🔹 CLICK OUTSIDE → close all
  document.addEventListener('click', function () {
    document.querySelectorAll('.has-dropdown ul:not([hidden])').forEach(function (menu) {
      menu.setAttribute('hidden', '');
      const trigger = menu.closest('.has-dropdown').querySelector('a,button');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  });

  // 🔹 ESC → close all + focus restore
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.has-dropdown ul:not([hidden])').forEach(function (menu) {
        menu.setAttribute('hidden', '');
        const trigger = menu.closest('.has-dropdown').querySelector('a,button');
        if (trigger) {
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus(); // 🔹 focus restore
        }
      });
    }
  });

  // 🔹 FOCUS OUT → close that dropdown
  document.querySelectorAll('.has-dropdown').forEach(function (item) {
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) {
        const menu = item.querySelector('ul');
        if (menu) {
          menu.setAttribute('hidden', '');
          const trigger = item.querySelector('a,button');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        }
      }
    });
  });

});












  // Wait until the page loads
  document.addEventListener('DOMContentLoaded', function() {
    // Get the drawer close button
    const drawerCloseButton = document.querySelector('.drawer__close-button');
    // Get the Add to Cart button
    const addToCartButton = document.getElementById('AddToCart');

    // Add click event to move focus
    if (drawerCloseButton && addToCartButton) {
      drawerCloseButton.addEventListener('click', function() {
        addToCartButton.focus();
      });
    }
  });

